import React from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonType, ButtonTextTransform } from 'react-magma-dom';

const SelectTrigger = ({ onOpenModal }) => (
  <Button
    type={ButtonType.button}
    textTransform={ButtonTextTransform.none}
    style={{ fontSize: 14 }}
    isFullWidth
    onClick={onOpenModal}
  >
    <i className="icon icon-settings main-button__icon-left font-16" />

    Select
  </Button>
);

SelectTrigger.propTypes = {
  onOpenModal: PropTypes.func.isRequired
};

export default SelectTrigger;
